import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';

import { BaseService } from './base.service';
import { Tag } from '../models/tag.model';
import { GradingInput, GradingHeaderInfo, GradingStagingSheet } from '../models/grading.model';
import { AutofillInstructions } from '../home/grading/grading/grading.component';
import { ImagePackage } from '../models/image-package.model';

@Injectable()
export class GradingService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getGradingSheetInputs(patientId: string, visitId: string, studyId: string): Promise<{[dataGroupName: string]: Array<GradingInput>}> {
    return this.get('grading/sheetInputs/' + patientId + '/' + visitId + '/' + encodeURIComponent(studyId));
  }

  async getGradingHeaderInfo(patientId: string, visitId: string, studyId: string): Promise<GradingHeaderInfo> {
    return this.get('grading/headerInfo/' + patientId + '/' + visitId + '/' + encodeURIComponent(studyId));
  }

  async saveGradingSheet(patientId: string, spreadsheetId: string, visit: string, studyId: string, metaDatas: any[], submit: boolean, doNotLock: boolean):
    Promise<GradingStagingSheet> {
    return this.post('grading/stagingSheet/' + patientId, {
      spreadsheetId: spreadsheetId,
      visit: visit,
      studyId: studyId,
      metaDatas:  metaDatas,
      submit: submit,
      doNotLock: doNotLock
    });
  }

  async getAutofill(spreadsheetId: string, columnId: string, value: number): Promise<AutofillInstructions[]> {
    return this.get('grading/autofill/' + spreadsheetId + '/' + columnId + '/' + value);
  }

  async escalate(patientId: string, visitId: string, spreadsheetId: string): Promise<GradingStagingSheet> {
    return this.post('grading/escalate', { patientId: patientId, visitId: visitId, spreadsheetId: spreadsheetId });
  }

  async lockData(imagePackageIds: number[]): Promise<any> {
    return this.post('grading/dataLock', { imagePackageIds: imagePackageIds });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/grading.service.ts